import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslocoModule } from "@ngneat/transloco";
import { LastUpdatedComponent } from "./last-updated.component";

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, TranslocoModule],
	declarations: [LastUpdatedComponent],
	exports: [LastUpdatedComponent],
})
export class LastUpdatedComponentModule {}
